export var getYearsRange = function (startYear, endYear) {
    return startYear > endYear
        ? [startYear]
        : Array(endYear - startYear + 1)
            .fill(null)
            .map(function (_, idx) { return startYear + idx; })
            .reverse();
};
